import React from "react";
import type { DiffWBSNode } from "../../../models";
import DiffSidebarNode from "../DiffSidebarNode/DiffSidebarNode";
import "./DiffSidebar.css";

interface Props {
  roots: DiffWBSNode[];
  onNavigate: (node: DiffWBSNode) => void;
}

const DiffSidebar: React.FC<Props> = ({ roots, onNavigate }) => {
  return (
    <aside className="diff-sidebar">
      <div className="diff-sidebar__header">
        <h3>WBS Tree</h3>
      </div>
      <div className="diff-sidebar__tree">
        {roots.map((root) => (
          <DiffSidebarNode
            key={root.wbs_path}
            node={root}
            depth={0}
            onNavigate={onNavigate}
          />
        ))}
      </div>
    </aside>
  );
};

export default DiffSidebar;
